export default "__VITE_ASSET__CLVl6ZxX__"